import { render, staticRenderFns } from "./smsList.vue?vue&type=template&id=4d232830&scoped=true"
import script from "./smsList.vue?vue&type=script&lang=js"
export * from "./smsList.vue?vue&type=script&lang=js"
import style0 from "./smsList.vue?vue&type=style&index=0&id=4d232830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d232830",
  null
  
)

export default component.exports